import classNames from 'classnames'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import { useTranslationRankmi, joinKeys } from 'helpers/translations.helper'
import { EnrolState } from 'enum'
import styles from './State.module.scss'

const prefixTranslation = 'administration.externalCourses'
interface StateProps {
  state: IExternalCourseParticipant['state']
}

const { Approved, Denied, Pending, Absent, ExcusedAbsence } = EnrolState

const keys = {
  [Approved]: { key: 'approved', icon: null },
  [Denied]: { key: 'denied', icon: null },
  [Pending]: { key: 'pending', icon: null },
  [Absent]: { key: 'absent', icon: null },
  [ExcusedAbsence]: { key: 'excusedAbsence', icon: null },
}

export const State = ({ state: index }: StateProps) => {
  const tRelative = useTranslationRankmi({
    prefix: joinKeys(prefixTranslation, 'participants.status'),
  })

  const { key, icon } = keys[index as keyof typeof keys] || keys[Pending]
  return (
    <span>
      <FontAwesomeIcon
        className={classNames(styles[key], 'mr-2')}
        icon={faCircle}
      />
      {tRelative(key)} {icon}
    </span>
  )
}
